import { html } from 'uhtml';
import ToggleMenu from '../../../00-basics/expandy/expandy.wsutogglemenu';

function HeaderMobileMenu(mainMenu) {
  const mobileMenu = mainMenu.cloneNode(true);
  mobileMenu.id = `${mainMenu.id}-mobile`;
  mobileMenu.className =
    'menu menu--vertical menu--theme-mobile menu--no-icons';
  mobileMenu.dataset.menutype = 'toggle';
  mobileMenu.dataset.menustate = 'closed';
  mobileMenu.setAttribute('role', 'navigation');
  mobileMenu.setAttribute('aria-labelledby', `${mobileMenu.id}-toggle`);

  const toggleButton = html.node`
    <div id="${mobileMenu.id}-toggle" aria-label="Quick Links">
      <span class='collapsed-only'>
        <i class='fas fa-bars'></i>
        Menu
      </span>
      <span class='expanded-only'>
        <i class='fas fa-times'></i>
        Close
      </span>
    </div>
  `;

  mainMenu.insertAdjacentElement('afterend', toggleButton);
  toggleButton.insertAdjacentElement('afterend', mobileMenu);
}

document.addEventListener('DOMContentLoaded', () => {
  const $ = (selector) => document.querySelectorAll(selector);

  $('#wsu-header-links').forEach(HeaderMobileMenu);
  $('[data-menutype=toggle]').forEach(ToggleMenu);

  // Have site menu opened on all homepages
  /* eslint no-return-assign: "error" */
  $(`
    .front .region-site-menu .block-menu,
    .department__front .region-site-menu .block-menu
  `).forEach((e) => (e.dataset.defaultstate = 'open'));
});
